import { z } from 'zod';
import { isoDateSchema, isoDateTimeSchema, uuidSchema } from '../common/primitives.js';
import { equityPositionSchema, founderStatusSchema } from '../founders/founders.js';
import { obligationSchema } from '../obligations/obligations.js';
import { taskSummarySchema } from '../tasks/tasks.js';
import { reportStateSchema } from '../updates/updates.js';
import { memberRoleSchema, memberStatusSchema } from '../workspace/workspace.js';
export const OUTSTANDING_ACTION_KINDS = [
    'MFA_ENROLLMENT_REQUIRED',
    'MFA_RECOMMENDED',
    'OBLIGATION_DUE_SOON',
    'CAP_TABLE_DRAFT_PENDING',
    'FOUNDER_PROFILE_MISSING',
    'INVITATION_PENDING',
    'VOTE_PENDING',
    'ROUND_AWAITING_FINALIZATION',
    'DECISION_DRAFT_PENDING',
    'TASK_OVERDUE',
    'TASK_DUE_SOON',
    'BLOCKER_WAITING',
    'WEEKLY_UPDATE_DUE',
    'FUNDING_CONTRIBUTION_DUE',
];
export const outstandingActionKindSchema = z.enum(OUTSTANDING_ACTION_KINDS);
export const ACTION_URGENCIES = ['URGENT', 'SOON', 'INFO'];
export const actionUrgencySchema = z.enum(ACTION_URGENCIES);
export const outstandingActionSchema = z.object({
    kind: outstandingActionKindSchema,
    urgency: actionUrgencySchema,
    title: z.string(),
    detail: z.string().nullable(),
    dueAt: isoDateTimeSchema.nullable(),
    /** Entity the action refers to, for deep links. */
    subjectId: uuidSchema.nullable(),
});
export const cabinetSchema = z.object({
    asOf: isoDateTimeSchema,
    workspace: z.object({ id: uuidSchema, name: z.string(), timezone: z.string() }),
    member: z.object({
        id: uuidSchema,
        displayName: z.string(),
        email: z.string(),
        role: memberRoleSchema,
        status: memberStatusSchema,
        title: z.string().nullable(),
        joinedAt: isoDateTimeSchema,
    }),
    founder: z
        .object({
        profileId: uuidSchema,
        legalName: z.string(),
        status: founderStatusSchema,
        founderSince: isoDateSchema.nullable(),
        currentEquity: equityPositionSchema.nullable(),
        /** A DRAFT cap-table version that would change this founder's share (not yet approved). */
        pendingEquityChange: z
            .object({
            capTableVersionId: uuidSchema,
            versionNumber: z.number().int(),
            effectiveFrom: isoDateSchema,
            percentage: z.string().nullable(),
        })
            .nullable(),
    })
        .nullable(),
    responsibilities: z.array(obligationSchema),
    outstandingActions: z.array(outstandingActionSchema),
    /** Open tasks owned by the member, earliest deadline first (capped). */
    myTasks: z.array(taskSummarySchema),
    /** Weekly update for the current period; `null` when updates are not configured or not expected. */
    weeklyUpdate: z
        .object({
        periodId: uuidSchema,
        startsOn: isoDateSchema,
        endsOn: isoDateSchema,
        dueAt: isoDateTimeSchema,
        state: reportStateSchema,
    })
        .nullable(),
    /** Personal funding position (founders with finance access); `null` otherwise. */
    funding: z
        .object({
        balances: z.array(z.object({
            currency: z.string(),
            owedByMe: z.string(),
            owedToMe: z.string(),
            overdue: z.string(),
        })),
        openContributions: z.number().int(),
        overdueContributions: z.number().int(),
    })
        .nullable(),
    security: z.object({ mfaEnabled: z.boolean(), mfaRequired: z.boolean() }),
});
//# sourceMappingURL=cabinet.js.map